"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RowSpaceWrapper = exports.TimelineCaption = exports.Timeline = exports.TimelineSubtitleExtra = exports.TimelineSubtitle = exports.TimelineWrapper = exports.Wrapper = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Wrapper = _styledComponents["default"].div.withConfig({
  displayName: "TrafficSpacesGridStyles2__Wrapper",
  componentId: "sc-1ddx6mv-0"
})(["width:100%;background:#3d4a69;position:relative;"]);

exports.Wrapper = Wrapper;

var TimelineWrapper = _styledComponents["default"].div.withConfig({
  displayName: "TrafficSpacesGridStyles2__TimelineWrapper",
  componentId: "sc-1ddx6mv-1"
})(["width:99%;display:flex;flex-direction:row;"]);

exports.TimelineWrapper = TimelineWrapper;

var TimelineSubtitle = _styledComponents["default"].div.withConfig({
  displayName: "TrafficSpacesGridStyles2__TimelineSubtitle",
  componentId: "sc-1ddx6mv-2"
})(["line-height:50px;color:#fff;font-weight:bold;margin-left:15px;border-top:5px solid #242e42;margin-top:10px;font-size:19px;"]);

exports.TimelineSubtitle = TimelineSubtitle;

var TimelineSubtitleExtra = _styledComponents["default"].span.withConfig({
  displayName: "TrafficSpacesGridStyles2__TimelineSubtitleExtra",
  componentId: "sc-1ddx6mv-3"
})(["font-size:13px;opacity:.6;"]);

exports.TimelineSubtitleExtra = TimelineSubtitleExtra;

var Timeline = _styledComponents["default"].div.withConfig({
  displayName: "TrafficSpacesGridStyles2__Timeline",
  componentId: "sc-1ddx6mv-4"
})(["min-width:", ";display:flex;flex-direction:row;padding:0.4rem 0 0 0;position:relative;height:25px;"], function (_ref) {
  var scrollWidth = _ref.scrollWidth;
  return scrollWidth || '2000px';
});

exports.Timeline = Timeline;

var TimelineCaption = _styledComponents["default"].div.withConfig({
  displayName: "TrafficSpacesGridStyles2__TimelineCaption",
  componentId: "sc-1ddx6mv-5"
})(["width:", ";color:", ";display:flex;flex-direction:row;margin-right:0.2rem;overflow:hidden;position:relative;overflow:visible;height:100%;&:hover,&.selected{background:rgb(137 147 172);color:#fff;& .sort-icon{display:block !important;}& .summary-icon{display:flex !important;}}"], function (_ref2) {
  var width = _ref2.width;
  return width || '100%';
}, function (_ref3) {
  var isCurrentTime = _ref3.isCurrentTime;
  return isCurrentTime ? 'white' : '#778197';
});

exports.TimelineCaption = TimelineCaption;

var RowSpaceWrapper = _styledComponents["default"].div.withConfig({
  displayName: "TrafficSpacesGridStyles2__RowSpaceWrapper",
  componentId: "sc-1ddx6mv-6"
})(["heigh:auto;background:#3d4a69;max-height:530px;overflow:auto;position:relative;padding-right:10px;box-sizing:border-box;"]);

exports.RowSpaceWrapper = RowSpaceWrapper;